import { createRouter, createWebHistory } from 'vue-router'

import store from './store'
const scrollBehavior = (to, from, savedPosition) => {
    if (to.hash) {
        const element = document.querySelector(to.hash);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    } else if (savedPosition) {
        window.scrollTo({ top: savedPosition.y, behavior: 'smooth' });
    }
    return new Promise(resolve => {
        setTimeout(() => {
            if (to.hash) {
                resolve({ el: to.hash, behavior: 'smooth' });
            } else {
                resolve(savedPosition ? { x: 0, y: savedPosition.y } : { x: 0, y: 0 });
            }
        }, 500); // Adjust timing as necessary for page load or transitions
    });
}
const router = createRouter({
    "history": createWebHistory(),
    base: process.env.BASE_URL,
    scrollBehavior,
    // This is for the scroll top when click on any router link
    routes: [
        {
            publicPath: '',
            historyApiFallback: true,
            path: '',
            component: () => import('./layouts/full-layout/Layout'),
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    name: '403',
                    path: '/403',
                    component: () => import('./views/errors/403'),
                },
                {
                    name: 'Home',
                    path: '',
                    component: () => import('./views/Home'),
                },
                {
                    name: 'Dashboard',
                    path: 'dashboard',
                    component: () => import('./views/Dashboard'),
                },
                {
                    name: 'Accesslevels',
                    path: 'accesslevels',
                    meta: { model: 'accesslevel', action: 'read' },
                    component: () => import('./views/accesslevels/List'),
                },
                {
                    name: 'Actionanddecisions',
                    path: 'actionanddecisions',
                    meta: { name: 'actionanddecision', action: 'read' },
                    component: () => import('./views/actionanddecisions/List'),
                },
                {
                    name: 'Actionanddecision edit',
                    path: 'actionanddecisions/:id',
                    meta: { model: 'actionanddecision' },
                    component: () => import('./views/actionanddecisions/Edit'),
                },
                {
                    name: 'Actionanddecisionitem edit',
                    path: 'actionanddecisionitems/:id',
                    meta: { model: 'actionanddecisionitems' },
                    component: () => import('./views/actionanddecisionitems/Edit'),
                },
                {
                    name: 'Ambienttemperatures',
                    path: 'ambienttemperatures',
                    meta: { model: 'ambienttemperature', action: 'read' },
                    component: () => import('./views/ambienttemperatures/List'),
                },
                {
                    name: 'Applications',
                    path: 'applications',
                    meta: { model: 'application', action: 'read' },
                    component: () => import('./views/applications/List'),
                },
                {
                    name: 'Articles',
                    path: 'articles',
                    meta: { name: 'article', action: 'read' },
                    component: () => import('./views/articles/List'),
                },
                {
                    name: 'Articles edit',
                    path: 'articles/:id',
                    meta: { model: 'article' },
                    component: () => import('./views/articles/Edit'),
                },
                {
                    name: 'Assets',
                    path: 'platforms',
                    meta: { name: 'asset', action: 'read' },
                    component: () => import('./views/assets/List'),
                },
                {
                    name: 'Atexcodes',
                    path: 'atexcodes',
                    meta: { model: 'atexcode', action: 'read' },
                    component: () => import('./views/atexcodes/List'),
                },
                {
                    name: 'Brands',
                    path: 'brands',
                    meta: { model: 'brand', action: 'read' },
                    component: () => import('./views/brands/List'),
                },
                {
                    name: 'Classifications',
                    path: 'classifications',
                    meta: { model: 'classification', action: 'read' },
                    component: () => import('./views/classifications/List'),
                },
                {
                    name: 'Characteristics',
                    path: 'characteristics',
                    meta: { model: 'characteristic', action: 'read' },
                    component: () => import('./views/characteristics/List'),
                },
                {
                    name: 'Climate',
                    path: 'climate',
                    meta: { model: 'climate', action: 'read' },
                    component: () => import('./views/climate/List'),
                },
                {
                    name: 'Companies',
                    path: 'companies',
                    meta: { model: 'company', action: 'read' },
                    component: () => import('./views/companies/List'),
                },
                {
                    name: 'Companies edit',
                    path: 'companies/:id',
                    meta: { model: 'company' },
                    component: () => import('./views/companies/Edit'),
                },
                {
                    name: 'Contact',
                    path: 'contacts',
                    meta: { model: 'contact', action: 'read' },
                    component: () => import('./views/contacts/List'),
                },
                {
                    name: 'Contact edit',
                    path: 'contacts/:id',
                    meta: { model: 'contact' },
                    component: () => import('./views/contacts/Edit'),
                },
                {
                    name: 'Conformitymarks',
                    path: 'conformitymarks',
                    meta: { model: 'conformitymark', action: 'read' },
                    component: () => import('./views/conformitymarks/List'),
                },
                {
                    name: 'Damagechances',
                    path: 'damagechances',
                    meta: { model: 'damagechance', action: 'read' },
                    component: () => import('./views/damagechances/List'),
                },
                {
                    name: 'Defects',
                    path: 'defects',
                    meta: { model: 'defect', action: 'read' },
                    component: () => import('./views/defects/List'),
                },
                {
                    name: 'Defects edit',
                    path: 'defects/:id',
                    meta: { model: 'defect' },
                    component: () => import('./views/defects/Edit'),
                },
                {
                    name: 'Defectrepairs',
                    path: 'defectrepairs',
                    meta: { model: 'defectrepair', action: 'read' },
                    component: () => import('./views/defectrepairs/List'),
                },
                {
                    name: 'Departments',
                    path: 'departments',
                    meta: { model: 'department', action: 'read' },
                    component: () => import('./views/departments/List'),
                },
                {
                    name: 'Departments edit',
                    path: 'departments/:id',
                    meta: { model: 'department' },
                    component: () => import('./views/departments/Edit'),
                },
                {
                    name: 'Deviationtemplates',
                    path: 'deviationtemplates',
                    meta: { model: 'deviationtemplate', action: 'read' },
                    component: () => import('./views/deviationtemplates/List'),
                },
                {
                    name: 'Distributionpanels',
                    path: 'distributionpanels',
                    meta: { model: 'distributionpanel', action: 'read' },
                    component: () => import('./views/distributionpanels/List'),
                },
                {
                    name: 'Distributiondevicefunctions',
                    path: 'distributiondevicefunctions',
                    meta: { model: 'distributiondevicefunction', action: 'read' },
                    component: () => import('./views/distributiondevicefunctions/List'),
                },
                {
                    name: 'Documents',
                    path: 'documents',
                    meta: { name: 'document', action: 'read' },
                    component: () => import('./views/documents/List'),
                },
                {
                    name: 'Documentation',
                    path: 'documentation',
                    component: () => import('./views/documentation/Index'),
                },
                {
                    name: 'Dnv Verification Register',
                    path: 'dnvverificationregisters',
                    meta: { model: 'dnvverificationregister', action: 'read' },
                    component: () => import('./views/dnvverificationregisters/List'),
                },
                {
                    name: 'Dnv Verification Register edit',
                    path: 'dnvverificationregisters/:id',
                    meta: { model: 'dnvverificationregister' },
                    component: () => import('./views/dnvverificationregisters/Edit'),
                },
                {
                    name: 'Employees',
                    path: 'employees',
                    meta: { model: 'employee', action: 'read' },
                    component: () => import('./views/employees/List'),
                },
                {
                    name: 'Employees edit',
                    path: 'employees/:id',
                    meta: { model: 'employee' },
                    component: () => import('./views/employees/Edit'),
                },
                {
                    name: 'Emergencies',
                    path: 'emergencies',
                    meta: { model: 'emergency', action: 'read' },
                    component: () => import('./views/emergencies/List'),
                },
                {
                    name: 'Environments',
                    path: 'environments',
                    meta: { model: 'environment', action: 'read' },
                    component: () => import('./views/environments/List'),
                },
                {
                    name: 'Equipmenttypes',
                    path: 'equipmenttypes',
                    meta: { model: 'equipmenttype', action: 'read' },
                    component: () => import('./views/equipmenttypes/List'),
                },
                {
                    name: 'Equipmenttypes edit',
                    path: 'equipmenttypes/:id',
                    meta: { model: 'equipmenttype' },
                    component: () => import('./views/equipmenttypes/Edit'),
                },
                {
                    name: 'Equipmentgroups',
                    path: 'equipmentgroups',
                    meta: { model: 'equipmentgroup', action: 'read' },
                    component: () => import('./views/equipmentgroups/List'),
                },
                {
                    name: 'Equipmentprotectionlevels',
                    path: 'equipmentprotectionlevels',
                    meta: { model: 'equipmentprotectionlevel', action: 'read' },
                    component: () => import('./views/equipmentprotectionlevels/List'),
                },
                {
                    name: 'Equipmentcategories',
                    path: 'equipmentcategories',
                    meta: { model: 'equipmentcategory', action: 'read' },
                    component: () => import('./views/equipmentcategories/List'),
                },
                {
                    name: 'Explosiveatmospheres',
                    path: 'explosiveatmospheres',
                    meta: { model: 'explosiveatmosphere', action: 'read' },
                    component: () => import('./views/explosiveatmospheres/List'),
                },
                {
                    name: 'Expertises',
                    path: 'expertises',
                    meta: { model: 'expertises', action: 'read' },
                    component: () => import('./views/expertises/List'),
                },
                {
                    name: 'Field sets',
                    path: 'fieldsets',
                    meta: { model: 'fieldset', action: 'read' },
                    component: () => import('./views/fieldsets/List'),
                },
                {
                    name: 'Fields',
                    path: 'fields',
                    meta: { model: 'field', action: 'read' },
                    component: () => import('./views/fields/List'),
                },
                {
                    name: 'Forms',
                    path: 'forms',
                    meta: { model: 'form', action: 'read' },
                    component: () => import('./views/forms/List'),
                },
                {
                    name: 'Form edit',
                    path: 'forms/:id',
                    meta: { model: 'form' },
                    component: () => import('./views/forms/Edit'),
                },
                {
                    name: 'Gasgroups',
                    path: 'gasgroups',
                    meta: { model: 'gasgroup', action: 'read' },
                    component: () => import('./views/gasgroups/List'),
                },
                {
                    name: 'Import assets',
                    path: 'importassets',
                    component: () => import('./views/importassets/Index'),
                },
                {
                    name: 'Import phases',
                    path: 'importphases',
                    component: () => import('./views/importphases/Index'),
                },
                {
                    name: 'Intensity',
                    path: 'intensity',
                    meta: { model: 'intensity', action: 'read' },
                    component: () => import('./views/intensity/List'),
                },
                {
                    name: 'Inspections',
                    path: 'inspections',
                    meta: { name: 'inspection', action: 'read' },
                    component: () => import('./views/inspections/List'),
                },
                {
                    name: 'Inspectionclasses',
                    path: 'inspectionclasses',
                    meta: { model: 'inspectionclass', action: 'read' },
                    component: () => import('./views/inspectionclasses/List'),
                },
                {
                    name: 'Inspectioninstitutes',
                    path: 'inspectioninstitutes',
                    meta: { model: 'inspectioninstitute', action: 'read' },
                    component: () => import('./views/inspectioninstitutes/List'),
                },
                {
                    name: 'Inspectioninstitutecertifications',
                    path: 'inspectioninstitutecertifications',
                    meta: { model: 'inspectioninstitutecertification', action: 'read' },
                    component: () => import('./views/inspectioninstitutecertifications/List'),
                },
                {
                    name: 'Inspectioncodes',
                    path: 'inspectioncodes',
                    meta: { model: 'inspectioncode', action: 'read' },
                    component: () => import('./views/inspectioncodes/List'),
                },
                {
                    name: 'Inspectioncertificates',
                    path: 'inspectioncertificates',
                    meta: { model: 'inspectioncertificate', action: 'read' },
                    component: () => import('./views/inspectioncertificates/List'),
                },
                {
                    name: 'Inspectioncertificates edit',
                    path: 'inspectioncertificates/:id',
                    meta: { model: 'inspectioncertificate' },
                    component: () => import('./views/inspectioncertificates/Edit'),
                },
                {
                    name: 'Iptypes',
                    path: 'iptypes',
                    meta: { model: 'iptype', action: 'read' },
                    component: () => import('./views/iptypes/List'),
                },
                {
                    name: 'Ipindications',
                    path: 'ipindications',
                    meta: { model: 'ipindication', action: 'read' },
                    component: () => import('./views/ipindications/List'),
                },
                {
                    name: 'Inspectiondelays',
                    path: 'inspectiondelays',
                    meta: { model: 'inspectiondelay', action: 'read' },
                    component: () => import('./views/inspectiondelays/List'),
                },
                {
                    name: 'Impactloads',
                    path: 'impactloads',
                    meta: { model: 'impactload', action: 'read' },
                    component: () => import('./views/impactloads/List'),
                },
                {
                    name: 'Jobtitles',
                    path: 'jobtitles',
                    meta: { model: 'jobtitle', action: 'read' },
                    component: () => import('./views/jobtitles/List'),
                },
                {
                    name: 'Jobtitles edit',
                    path: 'jobtitles/:id',
                    meta: { model: 'jobtitle' },
                    component: () => import('./views/jobtitles/Edit'),
                },
                {
                    name: 'Linevoltage',
                    path: 'linevoltage',
                    meta: { model: 'linevoltage', action: 'read' },
                    component: () => import('./views/linevoltage/List'),
                },
                {
                    name: 'Locations',
                    path: 'locations',
                    meta: { model: 'location', action: 'read' },
                    component: () => import('./views/locations/List'),
                },
                {
                    name: 'Markering',
                    path: 'markering',
                    meta: { model: 'markering', action: 'read' },
                    component: () => import('./views/markering/List'),
                },
                {
                    name: 'Materials',
                    path: 'materials',
                    meta: { model: 'material', action: 'read' },
                    component: () => import('./views/materials/List'),
                },
                {
                    name: 'Measurements',
                    path: 'measurements',
                    meta: { model: 'measurement', action: 'read' },
                    component: () => import('./views/measurements/List'),
                },
                {
                    name: 'Measurements edit',
                    path: 'measurements/:id',
                    meta: { model: 'measurement' },
                    component: () => import('./views/measurements/Edit'),
                },
                {
                    name: 'Meetings',
                    path: 'meetings',
                    meta: { name: 'meeting', action: 'read' },
                    component: () => import('./views/meetings/Index'),
                },
                {
                    name: 'Notes',
                    path: 'notes',
                    meta: { model: 'note', action: 'read' },
                    component: () => import('./views/notes/List'),
                },
                {
                    name: 'Notifications',
                    path: 'notifications',
                    meta: { name: 'notification', action: 'read' },
                    component: () => import('./views/notifications/Index'),
                },
                {
                    name: 'Planner',
                    path: 'planning',
                    component: () => import('./views/planner/List'),
                },
                {
                    name: 'Platformmanagement',
                    path: 'platformmanagement',
                    meta: { model: 'platformmanagement', action: 'read' },
                    component: () => import('./views/platformmanagement/List'),
                },
                {
                    name: 'Projects',
                    path: 'projects',
                    meta: { name: 'project', action: 'read' },
                    component: () => import('./views/projects/List'),
                },
                {
                    name: 'Project edit',
                    path: 'projects/:id',
                    meta: { model: 'project' },
                    component: () => import('./views/projects/Edit'),
                },
                {
                    name: 'Projectmanagement',
                    path: 'projectmanagement',
                    meta: { name: 'projectmanagement', action: 'read' },
                    component: () => import('./views/projectmanagement/List'),
                },
                {
                    name: 'Projectmanagement edit',
                    path: 'projectmanagement/:id',
                    meta: { model: 'projectmanagement' },
                    component: () => import('./views/projectmanagement/Edit'),
                },
                {
                    name: 'Projectmanagementquestions',
                    path: 'projectmanagementquestions',
                    meta: { name: 'projectmanagementquestion', action: 'read' },
                    component: () => import('./views/projectmanagementquestions/List'),
                },
                {
                    name: 'Punchlists',
                    path: 'punchlists',
                    meta: { name: 'punchlist', action: 'read' },
                    component: () => import('./views/punchlists/List'),
                },
                {
                    name: 'Punchlist edit',
                    path: 'punchlists/:id',
                    meta: { model: 'punchlist' },
                    component: () => import('./views/punchlists/Edit'),
                },
                {
                    name: 'Punchlistitem edit',
                    path: 'punchlistitems/:id',
                    meta: { model: 'punchlistitems' },
                    component: () => import('./views/punchlistitems/Edit'),
                },
                {
                    name: 'Profile',
                    path: 'profile',
                    component: () => import('./views/Profile'),
                },
                {
                    name: 'Powersystems',
                    path: 'powersystems',
                    meta: { model: 'powersystem', action: 'read' },
                    component: () => import('./views/powersystems/List'),
                },
                {
                    name: 'Protectionkinds',
                    path: 'protectionkinds',
                    meta: { model: 'protectionkind', action: 'read' },
                    component: () => import('./views/protectionkinds/List'),
                },
                {
                    name: 'Protections',
                    path: 'protections',
                    meta: { model: 'protection', action: 'read' },
                    component: () => import('./views/protections/List'),
                },
                {
                    name: 'Protectiontypes',
                    path: 'protectiontypes',
                    meta: { model: 'protectiontype', action: 'read' },
                    component: () => import('./views/protectiontypes/List'),
                },
                {
                    name: 'Protectionmethods',
                    path: 'protectionmethods',
                    meta: { model: 'protectionmethod', action: 'read' },
                    component: () => import('./views/protectionmethods/List'),
                },
                {
                    name: 'Procedures',
                    path: 'procedures',
                    meta: { name: 'procedure', action: 'read' },
                    component: () => import('./views/procedures/List'),
                },
                {
                    name: 'Procedures edit',
                    path: 'procedures/:id',
                    meta: { model: 'procedure' },
                    component: () => import('./views/procedures/Edit'),
                },
                {
                    name: 'Procedures planner',
                    path: 'procedures-planning',
                    component: () => import('./views/procedureplanner/List'),
                },
                {
                    name: 'Proceduresteps',
                    path: 'proceduresteps',
                    meta: { name: 'procedurestep', action: 'read' },
                    component: () => import('./views/proceduresteps/List'),
                },
                {
                    name: 'Preferredarticles',
                    path: 'preferredarticles',
                    meta: { model: 'preferredarticle', action: 'read' },
                    component: () => import('./views/preferredarticles/List'),
                },
                {
                    name: 'Questionnaires',
                    path: 'questionnaires',
                    meta: { model: 'questionnaire', action: 'read' },
                    component: () => import('./views/questionnaires/List'),
                },
                {
                    name: 'Questionnaires edit',
                    path: 'questionnaires/:id',
                    meta: { model: 'questionnaire' },
                    component: () => import('./views/questionnaires/Edit'),
                },
                {
                    name: 'Questionnaires fill',
                    path: 'fill-questionnaires/:id',
                    meta: { model: 'questionnaire' },
                    component: () => import('./views/questionnaires/Fill'),
                },
                {
                    name: 'Regulations',
                    path: 'regulations',
                    meta: { model: 'regulation', action: 'read' },
                    component: () => import('./views/regulations/List'),
                },
                {
                    name: 'Role',
                    path: 'roles',
                    meta: { model: 'role', action: 'read' },
                    component: () => import('./views/roles/List'),
                },
                {
                    name: 'Role Edit',
                    path: 'roles/:id',
                    meta: { model: 'role' },
                    component: () => import('./views/roles/Edit'),
                },
                {
                    name: 'Rooms',
                    path: 'rooms',
                    meta: { model: 'room', action: 'read' },
                    component: () => import('./views/rooms/List'),
                },
                {
                    name: 'Stof',
                    path: 'stof',
                    meta: { model: 'stof', action: 'read' },
                    component: () => import('./views/stof/List'),
                },
                {
                    name: 'Search',
                    path: 'search',
                    meta: { model: 'search' },
                    component: () => import('./views/search/Index'),
                },
                {
                    name: 'Inspections config',
                    path: 'inspectionsconfig',
                    component: () => import('./views/inspectionsconfig/Index'),
                },
                {
                    name: 'Settings Edit',
                    path: 'settings',
                    meta: { model: 'setting' },
                    component: () => import('./views/settings/Edit'),
                },
                {
                    name: 'Substances',
                    path: 'substances',
                    meta: { model: 'substance', action: 'read' },
                    component: () => import('./views/substances/List'),
                },
                {
                    name: 'Standarddeviations',
                    path: 'standarddeviations',
                    meta: { model: 'standarddeviation', action: 'read' },
                    component: () => import('./views/standarddeviations/List'),
                },
                {
                    name: 'Tags',
                    path: 'tags',
                    meta: { model: 'tag', action: 'read' },
                    component: () => import('./views/tags/List'),
                },
                {
                    name: 'Tagnumbers',
                    path: 'tagnumbers',
                    meta: { model: 'tagnumber', action: 'read' },
                    component: () => import('./views/tagnumbers/List'),
                },
                {
                    name: 'Tagnumbers edit',
                    path: 'tagnumbers/:id',
                    meta: { model: 'tagnumber' },
                    component: () => import('./views/tagnumbers/Edit'),
                },
                {
                    name: 'Templates',
                    path: 'templates',
                    meta: { model: 'template', action: 'read' },
                    component: () => import('./views/templates/List'),
                },
                {
                    name: 'Templates edit',
                    path: 'templates/:id',
                    meta: { model: 'template' },
                    component: () => import('./views/templates/Edit'),
                },
                {
                    name: 'Temperatureclasses',
                    path: 'temperatureclasses',
                    meta: { model: 'temperatureclass', action: 'read' },
                    component: () => import('./views/temperatureclasses/List'),
                },
                {
                    name: 'Todolists',
                    path: 'todolists',
                    meta: { name: 'todolist', action: 'read' },
                    component: () => import('./views/todolists/Index'),
                },
                {
                    name: 'Translations',
                    path: 'translations',
                    meta: { model: 'translation', action: 'read' },
                    component: () => import('./views/translations/List'),
                },
                {
                    name: 'Typesandsubtypes',
                    path: 'typesandsubtypes',
                    meta: { model: 'typesandsubtype', action: 'read' },
                    component: () => import('./views/typesandsubtypes/List'),
                },
                {
                    name: 'Usagefrequency',
                    path: 'usagefrequency',
                    meta: { model: 'usagefrequency', action: 'read' },
                    component: () => import('./views/usagefrequency/List'),
                },
                {
                    name: 'Vibrations',
                    path: 'vibrations',
                    meta: { model: 'vibration', action: 'read' },
                    component: () => import('./views/vibrations/List'),
                },
                {
                    name: 'Water',
                    path: 'water',
                    meta: { model: 'water', action: 'read' },
                    component: () => import('./views/water/List'),
                },
                {
                    name: 'Workflow',
                    path: 'workflows',
                    meta: { model: 'workflow', action: 'read' },
                    component: () => import('./views/workflows/List'),
                },
                {
                    name: 'Workflow Edit',
                    path: 'workflows/:id',
                    meta: { model: 'workflow' },
                    component: () => import('./views/workflows/Edit'),
                },
                {
                    name: 'Workequipmentgroups',
                    path: 'workequipmentgroups',
                    meta: { model: 'workequipmentgroup', action: 'read' },
                    component: () => import('./views/workequipmentgroups/List'),
                },
            ]
        },
        {
            name: 'Inspections edit',
            path: '/inspections/:id',
            meta: { model: 'inspection' },
            component: () => import('./views/inspections/Edit'),
        },
        {
            name: 'Import inspections',
            path: '/importinspections',
            component: () => import('./views/importinspections/Index'),
        },
        {
            name: 'Import defects',
            path: '/importdefects',
            component: () => import('./views/importdefects/Index'),
        },
        {
            name: 'Import measurements',
            path: '/importmeasurements',
            component: () => import('./views/importmeasurements/Index'),
        },
        {
            name: 'Login',
            path: '/login',
            component: () => import('./views/authentication/Login'),
        },
        {
            name: 'Error',
            path: '/error404',
            component: () => import('./views/Error'),
        },

        {
            path: '/authentication',
            component: () => import('./layouts/blank-layout/Blanklayout'),
        },
        {
            name: 'Complete registration',
            path: '/completeregistration',
            publicPath: '/completeregistration',
            component: () => import('./views/authentication/CompleteRegistration'),
        },
        {
            name: 'Password reset',
            path: '/resetpassword',
            publicPath: '/resetpassword',
            component: () => import('./views/authentication/PasswordReset'),
        },
        {
            publicPath: '',
            historyApiFallback: true,
            path: '',
            component: () => import('./layouts/full-layout/Layout'),
            children: [
                {
                    name: '403',
                    path: '/403',
                    component: () => import('./views/errors/403'),
                },
            ]
        },
    ],
})
router.beforeEach((to, from, next) => {
    store.state.loader = false;
    if(to.path === '/completeregistration' || to.path === '/resetpassword' || to.path === '/') {
        localStorage.removeItem("path");
    }
    else if(to.path !== '/login') {
        let path = to.path;
        if (to.query.id) {
            path += "?id=" + to.query.id;
        }
        localStorage.setItem("path", path);
    }
    if (to.matched.some(record => record.meta && record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
        } else {
            next('/login');
        }

    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.params.asset_id) {
        to.params.asset_id = parseInt(to.params.asset_id, 10) || null;
    }
    next();
})

export default router